import '../styles/CartItem.css';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GrClose } from 'react-icons/gr';
import { FaTrash } from 'react-icons/fa';
import { Alert, Box, Snackbar, Typography } from '@mui/material';
import { useCart } from '../context/CartContext';
import { useProducts } from '../context/ProductsContext';
import { useMemo, useState, useEffect } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import PromoPopup from "./PromoPopup";

export const CartItem = ({ item, editable = false }) => {
  //console.log("itemitemitemitemitemitemitemitemitemitemitemitemitemitemitemitemitemitem", item);
  const { chart, updateProductToChartAction, deleteProductFromChartAction, addProductToChartAction, RefreshProductToChartAction2 } = useCart();
  const { products } = useProducts();
  const [noStock, setNoStock] = useState(false);
  const [openStockAlert, setOpenStockAlert] = useState(false);
  const [productQuantity, setProductQuantity] = useState(item.amount);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [priceWithDiscount, setPriceWithDiscount] = useState(item.discountPrice);
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);


  const handleQuantityButton = (quantity) => {
    //console.log('quantity',quantity);
    //console.log('stockAmount',item.product.stockAmount);
    const effectiveQuantity = Math.min(Number(quantity), item.product.stockAmount);
   
    const overStock = Number(quantity) >= item.product.stockAmount
    setNoStock(overStock);
    setOpenStockAlert(overStock);
    setProductQuantity(effectiveQuantity)
    updateProductToChartAction(item.product, effectiveQuantity);
    //necesito averiguar por la 



    //console.log('product-product2', item.product);
    //console.log('product-gift2', priceWithDiscountList.Gifts);


    // console.log("item2: ", item);
    //console.log("Cartitem-handleQuantityButton: ", item);
  };

  const handleAddAndSubsQuantity = (quantity) => {
    //console.log('quantity',quantity);
    if (Number(quantity) > 0) {
      return handleQuantityButton(quantity)
    }
    return updateProductToChartAction(item.product, 0);
    //return deleteProductFromChartAction(item.product);
  };

  const handleRemoveFromCart = () => {
    updateProductToChartAction(item.product, 0);
    //deleteProductFromChartAction(item.product);
  }

  const handleQuantityChange = (e) => {
    handleQuantityButton(Number(e.target.value))
  }

  const handleQuantityBlur = (e) => {
    handleAddAndSubsQuantity(Number(e.target.value))
  }


  useEffect(() => {
    setPriceWithDiscount(chart.products.find(x => x.product.code == item.product.code).discountPrice);
  }, [item.product, products, chart])

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Detecta pantallas pequeñas
  const productName = isSmallScreen ? toTitleCase(item.product.shortName) : toTitleCase(item.product.name);

  function toTitleCase(string) {
    if (string === null || string == undefined) {
      string = '-';
    } else {
      let splitStr = string.toLowerCase().split(' ');

      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].slice(1);
        string = splitStr.join(' ');
      }
    }
    return string;
  }

  return (
    <Box className="card-item" sx={{ gap: { xs: '15px', md: editable ? '15px' : '50px' } }}>
      <div className="card-item-image">
        {(item.product.promotions != null) && (
          <div style={{ position: 'absolute', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 5, display: 'inline-flex', zIndex: 9999  }}>
            <div style={{ padding: 4, background: 'red', borderBottomRightRadius: 8, borderTopRightRadius: 8, justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex' }}>
              <div style={{ textAlign: 'center', color: '#FDFDFD', fontSize: 11, fontWeight: '700', lineHeight: '14px', wordWrap: 'break-word' }}>
                <button onClick={handleOpenPopup} style={{ fontSize: 16, color: "yellow" }}>ℹ️</button>
                {item.product.promotions[0].promotion}
              </div>
              <PromoPopup open={isPopupOpen} onClose={handleClosePopup} promotions={item.product.promotions} />
            </div>
          </div>
        )}
        <img
          src={item.product.imageUrl?.[0]?.imgUrl !== undefined ? 'https://images-dev.vedoraplus.com/komilon/' + item.product.imageUrl?.[0]?.imgUrl + '.webp' : '/assets/images/NoDisponible.png'}
          alt="Imagen Producto" />
      </div>
      {/* Detalle Productos CARRITO */}
      <div className="card-item-info">
        <p className="card-item-name">{productName}</p>
        <Typography component="span" color={'#6A6A6A'} sx={{ fontSize: { xs: '9px', md: '12px' }, textAlign: 'left' }}>
          sku:  {item.product.skuId} / {item.product.code}
        </Typography>
        <Typography component="span" color={'#6A6A6A'} sx={{ fontSize: { xs: '14px', md: '16px' }, textAlign: 'left' }}>
          S/ {
          (item.product.salePrice).toFixed(1)} X {item.product.measurementUnit
          } UN
        </Typography>
        {typeof item.amount === 'number' && !isNaN(item.amount) && item.amount < item.product?.saleMin && (
          <Typography
            sx={{
              fontSize: { xs: '11px', md: '15px' },
              color: 'red',
              textAlign: 'left',
              paddingTop: '0px',
            }}
          >
            Mínimo {item.product?.saleMin} unidades
          </Typography>
        )}
      </div>

      {!editable ? <p className="card-item-amount">X{item.amount}</p> : ''}

      {editable ? (
        <div className="card-item-remove">
          <button id={`btn-remove-${item?.product?.code}`} className="btn-remove-item" onClick={handleRemoveFromCart}>
            {/* <GrClose /> */}
            <FaTrash style={{ display: item.product?.bGift == true ? "none" : "inline-block" }} />
            {/* <FaTrash  /> */}
          </button>
        </div>
      ) : (
        ''
      )}

      <div className="card-item-values">
        <div className="card-item-prices">
          {
            (priceWithDiscount?.toFixed(3) !== item?.product?.salePrice?.toFixed(3) && editable) ?
              (
                <p className="card-item-price">S/. {(item.product?.salePrice * item.amount)?.toFixed(1)}</p>
              )
              :
              ''
          }
          <p className="card-item-discount">S/. {(priceWithDiscount * item.amount).toFixed(1)}</p>
        </div>
        {editable ? (
          <div className="card-item-quantity">
            <button id={`btn-subs-${item?.product?.code}`} onClick={() => handleAddAndSubsQuantity(item.amount - 1)} disabled={item.amount === 1 || item.product.bGift == true}
              style={{ display: item.product?.bGift == true ? "none" : "inline-block" }}>
              <FaMinus size={20} />
            </button>
            <input className="cart-item-input" type="number" value={item.amount} onBlur={handleQuantityBlur} onChange={handleQuantityChange} />
            <button id={`btn-add-${item?.product?.code}`} disabled={noStock || item.product?.bGift} onClick={() => handleAddAndSubsQuantity(item.amount + 1)}
              style={{ display: item.product?.bGift == true ? "none" : "inline-block" }}>
              <FaPlus size={20} />
            </button>
          </div>
        ) : (
          ''
        )}
      </div>



      <Snackbar open={openStockAlert} autoHideDuration={6000} onClose={() => setOpenStockAlert(false)}>
        <Alert onClose={() => setOpenStockAlert(false)} severity="warning">
          {'¡Solo ' + (item.product.stockAmount === 1 ? 'queda ' + item.product.stockAmount + ' unidad' : 'quedan ' + item.product.stockAmount + ' unidades') + ' en stock!'}
        </Alert>
      </Snackbar>
    </Box>
  );
};
